import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { dialogActions } from '../components/dialog/slice/dialog-slice';
import { JpegChecker } from './jpg-checker';

/**
 * 通常注文（file-drop-zone等）と共通の「プログレッシブJPEG除外」ダイアログ本文を返す。
 * 対象ファイル名は最大20件まで列挙し、超過分は件数のみ表示する。
 */
export const getProgressiveJpegRejectMessage = (progressive: File[]): string[] => {
  const show = progressive.slice(0, 20).map((f) => `・${f.name}`);
  const more = progressive.length > 20 ? [`...他 ${progressive.length - 20} 件`] : [];
  return [
    `プログレッシブJPEGが ${progressive.length} 件含まれていました。`,
    'ベースラインJPEGに変換してから再度アップロードしてください。',
    '',
    ...show,
    ...more,
  ];
};

/**
 * プログレッシブJPEGを取り込み対象から除外し、残り（非プログレッシブ）を返す。
 * 除外対象があった場合は通常注文と同文言のダイアログを表示する。
 */
export const excludeProgressiveJpegs = async (dispatch: Dispatch<AnyAction>, files: File[]): Promise<File[]> => {
  const progressive: File[] = [];
  const sequential: File[] = [];
  // 数百枚単位のバッチがあり得るため、全ファイル同時読み込みは避けて1枚ずつ判定する
  for (const f of files) {
    (await JpegChecker.isProgressiveJpeg(f) ? progressive : sequential).push(f);
  }
  if (progressive.length > 0) {
    dispatch(dialogActions.pushMessage({
      title: '確認',
      message: getProgressiveJpegRejectMessage(progressive),
      buttons: [
        { label: 'OK', callback: () => dispatch(dialogActions.pop()) },
      ],
    }));
  }
  return sequential;
};
